<template>
  <Bar :chart-data="chartData" :chart-options="chartOptions" ref="barchart" />
</template>

<script>
import { mapGetters } from 'vuex';
import { Bar } from 'vue-chartjs/legacy';

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
);

export default {
  name: 'BarChart',
  components: { Bar },
  props: {
    labels: {
      type: Array,
      required: true,
      default: () => [],
    },
    datasets: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      chartData: {
        labels: this.labels,
        datasets: this.datasets,
      },

    };
  },
  computed: {
    ...mapGetters(['getDarkmode']),
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          bar: {
            borderWidth: 2,
          },
        },
        plugins: {
          title: {
            display: true,
            text: this.title,
            color: this.getDarkmode ? '#56a3e0' : '#424c55',
          },
          legend: {
            display: true,
            labels: {
              color: this.getDarkmode ? '#99afbc' : '#424c55',
            },
          },
        },
        scales: {
          x: {
            grid: {
              color: this.getDarkmode ? '#31383d' : '#99afbc',
            },
            ticks: { color: this.getDarkmode ? '#99afbc' : '#424c55' },
          },
          y: {
            grid: {
              color: this.getDarkmode ? '#31383d' : '#99afbc',
            },
            ticks: { color: this.getDarkmode ? '#99afbc' : '#424c55' },
          },
        },
      };
    },
  },
  watch: {
    getDarkmode() {
      this.$refs.barchart.renderChart(this.chartData, this.chartOptions);
    },
  },
};
</script>
